// lib/types/rights.ts
// Auction Engine v2.2 – Rights Layer Types
// Last Updated: 2025-11-13

export enum RightType {
  Mortgage = "mortgage",
  Pledge = "pledge",
  ProvisionalSeizure = "provisional_seizure",
  Seizure = "seizure",
  Injunction = "injunction",
  Leasehold = "leasehold",
  TenantProtected = "tenant_protected",
  TenantUnprotected = "tenant_unprotected",
  Lien = "lien",
  StatutorySurface = "statutory_surface",
  SurfaceRight = "surface_right",
  Easement = "easement",
  GraveRight = "grave_right",
  PriorLeasehold = "prior_leasehold",
  PriorTenant = "prior_tenant",
  TaxLien = "tax_lien",
  NoticeRegistry = "notice_registry",
  ProvisionalRegistry = "provisional_registry",
}

export interface Rights {
  assumableRightsTotal: number;
  evictionCostEstimated: number;
  evictionRisk: number; 
  riskFlags: string[];

  breakdown: Array<{
    type: RightType;
    inheritable: boolean;
    payout: number;
    risk: number;
  }>;
}

/**
 * 예상배당표 행 (Allocation Table Row)
 * Rights.breakdown을 기반으로 배당표 형식으로 변환된 데이터
 */
export interface AllocationRow {
  /** 배당 순위 (1순위가 가장 우선) */
  rank: number;
  
  /** 채권 종류 (한글 표시용) */
  creditorType: string;
  
  /** 채권자 이름 */
  creditor: string;
  
  /** 채권액 (설정액) */
  amount: number;
  
  /** 배당 예상액 (실제 배당받을 금액) */
  expectedAllocation: number;
  
  /** 말소 여부 ("소멸" | "잔존") */
  willExtinguish: "소멸" | "잔존";
  
  /** 기준권리 여부 (말소기준권리인지) */
  isBaseRight?: boolean;
  
  /** 대항력 여부 (임차인 보증금의 경우) */
  hasCountervailingPower?: boolean;
}

/**
 * 예상배당표 전체 데이터
 */
export interface AllocationTable {
  /** 배당표 행 배열 (순위 순서대로 정렬됨) */
  rows: AllocationRow[];
  
  /** 총 배당 예상액 */
  totalAllocation: number;
  
  /** 기준권리 이후 총 소멸 예상액 */
  totalExtinguished: number;
}